"use client";

export default function MobileDesktopTip() {
  return (
    <div className="mx-auto mt-3 max-w-3xl px-6">
      <p className="text-center text-[11px] leading-relaxed text-gray-700">
        <span className="font-bold text-info">Tip:</span>{" "}
        WisWiz werkt het best op tablet of computer
      </p>
    </div>
  );
}
